'use client';

import React, { useMemo, useState } from 'react';
import { Animate } from 'react-animate-mount';

import Image from 'next/image';

import plusIcon from '@/assets/icons/plus-small-icon.svg';
// import minusIcon from '@/assets/icons/ezship-minus-small-icon.svg';
import MinusIcon from '@/components/svg/MinusIcon';
import cn from '@/helpers/utils/classNames';

interface IAccordionProps {
  title?: string;
  children: React.ReactNode;
  open?: boolean;
  containerClassName?: string;
  headingClassName?: string;
  onClick?: () => void;
  iconColor?: string;
}

const Accordion = ({
  title,
  children,
  open,
  containerClassName,
  headingClassName,
  onClick,
  iconColor,
}: IAccordionProps) => {
  const [isOpen, setIsOpen] = useState(false);
  useMemo(() => {
    if (open) return setIsOpen(open);
  }, [open]);

  return (
    <div className={containerClassName}>
      <h3
        className={cn(
          'v2-font-sweet-sans-pro-semi-bold v2-capitalize v2-font-semibold v2-text-base v2-mt-2 v2-text-neutral-800 v2-flex v2-justify-between v2-items-center',
          headingClassName
        )}
        onClick={() => {
          setIsOpen(!isOpen);
          onClick && onClick();
        }}
        role="button"
      >
        {title}
        {isOpen ? (
          // <Image src={minusIcon} alt="close" className="v2-ml-auto" />
          <MinusIcon stroke={iconColor} />
        ) : (
          <Image src={plusIcon} alt="open" className="v2-ml-auto" />
        )}
      </h3>
      <Animate show={isOpen} type="slide">
        {children}
      </Animate>
    </div>
  );
};

export default Accordion;
